import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Download } from "lucide-react";
import { useCatalog } from "../lib/useCatalog";
import { InstallCommands } from "../components/InstallCommands";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

export default function InstallGuide() {
  const { data, isLoading } = useCatalog();
  const [params, setParams] = useSearchParams();
  const [modelId, setModelId] = useState(params.get("model") || "");

  useEffect(() => {
    if (data && !data.models.find((m) => m.id === modelId)) setModelId(data.models[0]?.id || "");
  }, [data, modelId]);

  const model = data?.models.find((m) => m.id === modelId);
  const choose = (id) => { setModelId(id); setParams({ model: id }); };

  return (
    <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6" data-testid="install-guide-page">
      <div className="flex items-center gap-2 text-xs font-mono2 uppercase tracking-widest text-primary">
        <Download className="h-3.5 w-3.5" /> Guide d'installation
      </div>
      <h1 className="mt-2 font-head text-4xl font-bold sm:text-5xl">Lancez un LLM chez vous</h1>
      <p className="mt-3 text-muted-foreground">
        Choisissez un modèle, votre outil et votre système : on vous donne le lien de téléchargement et la commande exacte à copier.
      </p>

      <div className="mt-8 space-y-2">
        <div className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">Modèle</div>
        <Select value={modelId} onValueChange={choose} disabled={isLoading}>
          <SelectTrigger data-testid="install-guide-model-select" className="w-full sm:w-[360px]">
            <SelectValue placeholder="Chargement…" />
          </SelectTrigger>
          <SelectContent>
            {data?.models.map((m) => (
              <SelectItem key={m.id} value={m.id}>{m.name} · {m.params}B</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {model && (
        <div className="mt-6 rounded-xl border border-[#1E2638] bg-[#0F141C] p-5 sm:p-6">
          <h2 className="mb-4 font-head text-lg font-bold" data-testid="install-guide-model-name">{model.name}</h2>
          <InstallCommands key={model.id} model={model} />
        </div>
      )}
    </div>
  );
}
